/** Standard ROAS baseline / report day horizons */
export const ROAS_STANDARD_DAYS = [0, 3, 7, 14, 30, 45, 60, 90, 120, 150, 180]

export const ROAS_STANDARD_DAY_OPTIONS = ROAS_STANDARD_DAYS.map((day) => ({
  label: `Day ${day}`,
  value: String(day),
}))

/** Key used in `/drs/baselines/all` grouped response */
export function getBaselineDayKey(targetDay) {
  return `day${targetDay}`
}

/** Days that have legacy fallback defaults when no baseline is configured */
export const ROAS_BASELINE_DEFAULT_DAYS = [0, 3, 7, 14]
